/**
 * Resolve the booking-flow entry route from dashboard availability.
 *
 * CWR 1.2 — single source of truth shared by the ClientShell FAB ("Quick book")
 * and the Home "Book a Session" button, so the two cannot fork. Extracted
 * verbatim from the original BookingHubPage.handleBookClick logic.
 *
 * Returns the path to navigate to, or `null` when nothing is bookable (the
 * caller surfaces a toast). The caller is responsible for recipient-token
 * attribution (`withRecipientToken`) and navigation.
 */
export interface BookAvailability {
  hasServices: boolean;
  hasEvents: boolean;
}

/**
 * The catalog tab Book opens (shared-client-screens Decision C, rule 1): Services when the
 * studio has a service, Events when it has only events, null when nothing is bookable. The app
 * opens its one catalog at /book; the website maps the tab to /services or /events.
 */
export function resolveBookTab(availability: BookAvailability): 'services' | 'events' | null {
  if (availability.hasServices) return 'services';
  if (availability.hasEvents) return 'events';
  return null;
}

export function resolveBookTarget(availability: BookAvailability): string | null {
  // CWR 2.2 — the FAB + Home Book button open the redesigned catalog at /book
  // (Services + Events tabs). Browse-only until 2.4 wires the detail page.
  return resolveBookTab(availability) ? '/book' : null;
}
